import * as yup from 'yup';
import { Inscription } from '../entities';

export const schemaInscription = yup.object().shape<Inscription>({
    nomEcole: yup.string().required('Ce champ est requis'),
    idCss: yup.number().typeError('Ce champ est requis').required('Ce champ est requis'),
    nomContact: yup.string().required('Ce champ est requis'),
    prenomContact: yup.string().required('Ce champ est requis'),
    courrielContact: yup
        .string()
        .email('Ce champ doit contenir une adresse courriel valide')
        .required('Ce champ est requis'),
    telContact: yup.string().required('Ce champ est requis'),
});
